import React from 'react';
import AnnouncementImage from 'assets/images/dashboard/announcement.svg';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { SET_MODAL_STATUS, CLEAR_DATA } from 'store/actions';
import { setIsLoggedIn, SET_SUBSCRIBED } from 'store/Authentication/actions';
function Success() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userDataParse = localStorage.getItem('diologUserData') ? JSON.parse(localStorage.getItem('diologUserData')) : {};
    return (
        <>
            <Box className="modal-hero">
                <img src={AnnouncementImage} alt="announcement" />
            </Box>
            <Box className="modal-body">
                <Typography variant="h2" component="h2">
                    You have now activated {userDataParse?.plan} plan
                </Typography>
            </Box>
            <Box className="modal-footer pt-0">
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            className="alternate w-full"
                            onClick={() => {
                                navigate('/dashboard');
                                dispatch({ type: SET_MODAL_STATUS, modalStatus: false });
                                dispatch({
                                    type: SET_SUBSCRIBED,
                                    hasSubscribed: 'active'
                                });
                            }}
                        >
                            Back to dashboard
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default Success;
